import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const PORTAL_TOKEN_KEY = "jms_portal_token";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PortalAuthContext = createContext({
  client: null,
  token: null,
  loading: true,
  login: async () => {},
  logout: () => {},
});

// Dedicated axios instance so the portal token never leaks into the employee api.
const portalApi = axios.create({ baseURL: API });
portalApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function PortalAuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem(PORTAL_TOKEN_KEY) || null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const t = localStorage.getItem(PORTAL_TOKEN_KEY);
    if (!t) { setClient(null); setToken(null); setLoading(false); return; }
    try {
      const { data } = await portalApi.get("/portal/auth/me");
      setClient(data);
      setToken(t);
    } catch {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
      setClient(null); setToken(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const login = async (full_name, birth_date, whatsapp) => {
    const { data } = await portalApi.post("/portal/auth/login", { full_name, birth_date, whatsapp });
    localStorage.setItem(PORTAL_TOKEN_KEY, data.token);
    setToken(data.token);
    setClient(data.client);
    return data.client;
  };

  const logout = async () => {
    // AP-076 F3.1 · avisa o backend p/ apagar live_session e registrar evento
    // no Centro de Monitoramento (best-effort — nunca bloqueia o logout).
    try { await portalApi.post("/portal/auth/logout"); } catch (_) {}
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    setToken(null);
    setClient(null);
  };

  return (
    <PortalAuthContext.Provider value={{ client, token, loading, login, logout }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export const usePortalAuth = () => useContext(PortalAuthContext);
export { portalApi };
